<template>
  <custom-callout
    :border-color="getStatusColor"
    :class-main="`${getBackgroundColor}`"
    :has-toggle="false"
    :opened="isCancelMode"
  >
    <div class="row mx-auto">
      <div
        class="row mx-auto col-12 col-md-2 border-right align-items-center pr-5"
      >
        <div
          class="d-flex flex-column justify-content-center align-items-center"
        >
          <div
            :class="
              `badge d-flex flex-column badge-pill font-16 py-2 mt-2 w-70 color-black bg-${getStatusColor}`
            "
          >
            {{ data.statusName | empty }}
          </div>
          <div class="col-12 mt-2 text-center">
            <div>
              Área:
            </div>
            <div class="color-black font-weight-bold">
              <img
                alt=""
                class="pr-1 pb-1"
                :src="getImageByArea(data.areaId)"
                width="25px"
              />
              <span>{{ data.areaName | empty }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!isTecnicalAssistance" class="col-12 col-md-8 pl-5">
        <div class="row my-2">
          <div class="col-12 col-md-6">
            <div>
              <span class="color-gray-6 d-block font-14">
                {{ isEvaluationTherapyArea ? 'Proveedor:' : 'Porteador:' }}
              </span>
              <span class="font-16 color-black">
                {{ serviceProvider | empty }}
              </span>
            </div>
          </div>
          <div v-if="isEvaluationTherapyArea" class="col-12 col-md-6">
            <div>
              <span class="color-gray-6 d-block font-14">
                Lugar de Servicio:
              </span>
              <span class="font-16 color-black">
                {{ data.locationService | empty }}
              </span>
            </div>
          </div>
        </div>
        <div class="row my-2">
          <div class="col-12 col-md-3">
            <div>
              <span class="color-gray-6 d-block font-14">
                Semestre:
              </span>
              <span class="font-16 color-black">
                {{ semester | empty }}
              </span>
            </div>
          </div>
          <div class="col-12 col-md-3">
            <div>
              <span class="color-gray-6 d-block font-14">
                Tipo de Cuestionario:
              </span>
              <span class="font-16 color-black">
                {{ type | empty }}
              </span>
            </div>
          </div>
          <div class="col-12 col-md-3">
            <div>
              <span class="color-gray-6 d-block font-14">
                Disciplina:
              </span>
              <span class="font-16 color-black">
                {{ data.discipline | empty }}
              </span>
            </div>
          </div>
          <div v-if="!isEvaluationTherapyArea" class="col-12 col-md-3">
            <div>
              <span class="color-gray-6 d-block font-14">
                Tipo de Servicio:
              </span>
              <span class="font-16 color-black">
                {{ data.serviceName | empty }}
              </span>
            </div>
          </div>
          <div v-if="isEvaluationTherapyArea" class="col-12 col-md-3">
            <div>
              <span class="color-gray-6 d-block font-14">
                Nombre de Especialista:
              </span>
              <span class="font-16 color-black">
                {{ data.specialist | empty }}
              </span>
            </div>
          </div>
        </div>
        <div class="row my-2">
          <div v-if="!isTeacherType" class="col-md-3">
            <div>
              <span class="color-gray-6 d-block font-14">
                Número SIE:
              </span>
              <span class="font-16 color-black">
                {{ data.onlySIE | empty }}
              </span>
            </div>
          </div>
          <div v-if="!isTeacherType" class="col-12 col-md-3">
            <div>
              <span class="color-gray-6 d-block font-14">
                Nombre del Estudiante:
              </span>
              <span class="font-16 color-black">
                {{ data.onlyStudentName | empty }}
              </span>
            </div>
          </div>
          <div v-if="isTeacherType" class="col-12 col-md-3">
            <div>
              <span class="color-gray-6 d-block font-14">
                Nombre de Maestro:
              </span>
              <span class="font-16 color-black">
                {{ data.teacher | empty }}
              </span>
            </div>
          </div>
          <div v-if="!isTeacherType" class="col-12 col-md-5">
            <validation-observer ref="editableEmailObserver">
              <div v-if="isEmailEditableMode" class="col-12 p-0">
                <validation-provider
                  v-slot="{ errors }"
                  class="col-12 row"
                  :custom-messages="{
                    required: 'El correo electrónico es requerido.',
                    email: 'El correo electrónico no es válido.',
                  }"
                  :rules="'required|email'"
                >
                  <div class="col-10 row p-0">
                    <custom-input
                      id="editable-email-input"
                      v-model="emailInput"
                      class="col-12"
                      label="Correo Electrónico de Estudiante:"
                    />
                  </div>
                  <div class="col-2 d-flex align-items-end">
                    <action-button
                      id="btn-cancel-editable-email"
                      i="fas fa-times-circle"
                      variant="outline-danger mr-2"
                      @click="setIsEditableMode"
                    />
                    <action-button
                      id="btn-save-updated-email"
                      i="fas fa-save"
                      variant="success"
                      @click="onSaveUpdatedEmail"
                    />
                  </div>
                  <custom-error
                    v-if="errors[0]"
                    :message="errors[0]"
                    variant="no-border mt-1"
                  />
                </validation-provider>
              </div>
              <div v-else class="col-12 p-0">
                <span class="color-gray-6 d-block font-14">
                  Correo Electrónico de Estudiante:
                </span>
                <span class="font-16 color-black">
                  {{ email | empty }}
                </span>
              </div>
            </validation-observer>
          </div>
        </div>
        <div v-if="isCanceled && data.cancellationComment" class="row my-2">
          <div class="col-12">
            <div>
              <span class="color-gray-6 d-block font-14">
                Comentario de Cancelación:
              </span>
              <span class="font-16 color-black">
                {{ data.cancellationComment | empty }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="col-12 col-md-8 pl-5">
        <div class="row my-2 p-4">
          <div class="col-12 col-md-3">
            <div>
              <span class="color-gray-6 d-block font-14">
                Número de Ticket:
              </span>
              <span class="font-16 color-black">
                {{ data.ticketNumber | empty }}
              </span>
            </div>
          </div>
          <div class="col-12 col-md-3">
            <div>
              <span class="color-gray-6 d-block font-14">
                Nombre:
              </span>
              <span class="font-16 color-black">
                {{ data.name | empty }}
              </span>
            </div>
          </div>
          <div class="col-12 col-md-3">
            <validation-observer ref="editableEmailObserver">
              <div v-if="isEmailEditableMode" class="col-12 p-0">
                <validation-provider
                  v-slot="{ errors }"
                  class="col-12 row"
                  :custom-messages="{
                    required: 'El correo electrónico es requerido.',
                    email: 'El correo electrónico no es válido.',
                  }"
                  :rules="'required|email'"
                >
                  <div class="col-10 row p-0">
                    <custom-input
                      id="editable-email-input"
                      v-model="emailInput"
                      class="col-12"
                      label="Correo Electrónico:"
                    />
                  </div>
                  <div class="col-2 d-flex align-items-end">
                    <action-button
                      id="btn-cancel-editable-email"
                      i="fas fa-times-circle"
                      variant="outline-danger mr-2"
                      @click="setIsEditableMode"
                    />
                    <action-button
                      id="btn-save-updated-email"
                      i="fas fa-save"
                      variant="success"
                      @click="onSaveUpdatedEmail"
                    />
                  </div>
                  <custom-error
                    v-if="errors[0]"
                    :message="errors[0]"
                    variant="no-border mt-1"
                  />
                </validation-provider>
              </div>
              <div v-else class="col-12 p-0">
                <span class="color-gray-6 d-block font-14">
                  Correo Electrónico:
                </span>
                <span class="font-16 color-black">
                  {{ email | empty }}
                </span>
              </div>
            </validation-observer>
          </div>
          <div class="col-12 col-md-3">
            <div>
              <span class="color-gray-6 d-block font-14">
                Persona que trabajó el caso:
              </span>
              <span class="font-16 color-black">
                {{ data.resolvedByName | empty }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-2 d-flex justify-content-end pr-5">
        <dropdown
          v-if="anyVisibleAction"
          id="on-detail-btn-identifier"
          class="mt-2"
          :items="actionItems"
          title="Acciones"
        />
      </div>
    </div>
    <template #edition>
      <questionnaire-cancellation
        @on-cancel="abortCancelHandler"
        @on-save="cancelationHandler"
      />
    </template>
  </custom-callout>
</template>

<script>
//libs components
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import Dropdown from 'dropdown';
import CustomInput from 'CustomInput';
import CustomError from 'custom-error';
import alertMixin from '@/mixins/alert.mixin';

//services
import {
  updateFamiliarQuestionnaireEmail as _updateFamiliarQuestionnaireEmail,
  resendEmail as _resendEmail,
  cancelQuestionnaire as _cancelQuestionnaire,
} from '@/modules/serviceSatisfactionQuestionnaire/api.js';

import _generalApi from '@/modules/app/api.js';

//Constants
import {
  questionnaireTypes,
  questionnaireGroupTypes,
  parseStateColorByQuestionnaireGroupType,
} from '@/utils/constants/questionnaireTypes';
import serviceSatisfactionQuestionnaireStatuses, {
  parseStateColorByQuestionnaireStatus,
} from '@/utils/shared/constants/serviceSatisfactionQuestionnaireStatuses';
import { questionnaireArea } from '@/utils/constants/questionnaireArea.js';

//Components
import QuestionnaireCancellation from '@/views/provider/service-satisfaction-questionnaire/components/QuestionnaireCancellation.vue';

export default {
  name: 'ResultRow',
  components: {
    QuestionnaireCancellation,
    CustomCallout,
    ActionButton,
    CustomInput,
    CustomError,
    Dropdown,
  },
  mixins: [alertMixin],
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isEmailEditableMode: false,
      emailInput: null,
      email: null,
      isCancelMode: false,
    };
  },
  computed: {
    type() {
      return this.data?.questionnaireTypeId ===
        questionnaireTypes.TeacherTherapy
        ? questionnaireGroupTypes.Maestro
        : questionnaireGroupTypes.Familia;
    },
    semester() {
      return this.data?.semester === 1 ? 'Primero' : 'Segundo';
    },
    getStatusColor() {
      return parseStateColorByQuestionnaireStatus(this.data?.statusId);
    },
    getBackgroundColor() {
      return parseStateColorByQuestionnaireGroupType(this.type);
    },
    isTeacherType() {
      return (
        this.data?.questionnaireTypeId === questionnaireTypes.TeacherTherapy
      );
    },
    familyImg() {
      return require('@/assets/img/family.svg');
    },
    transportationImg() {
      return require('@/assets/img/bus.svg');
    },
    evaluationThrpyImg() {
      return require('@/assets/img/hands-holding-child.svg');
    },
    tecnicalAssistanceImg() {
      return require('@/assets/img/tecnical-assistance.svg');
    },
    actionItems() {
      return [
        {
          name: 'edit',
          label: 'Editar correo electrónico',
          icon: 'fas fa-edit text-green pr-1',
          visible:
            !this.isTeacherType &&
            this.userHasPermissions(
              'provider.satisfactionquestionnaire.search.editemail'
            ),
          click: () => this.setIsEditableMode(true),
        },
        {
          name: 'copy-url',
          label: 'Copiar enlace cuestionario',
          icon: 'fas fa-link text-green pr-1',
          visible:
            this.userHasPermissions(
              'provider.satisfactionquestionnaire.search.copyurl'
            ) && this.IsInProgress,
          click: () => this.copyUrl(),
        },
        {
          name: 'resend-email',
          label: 'Reenviar correo electrónico',
          icon: 'fas fa-undo-alt text-green pr-1',
          visible:
            !this.isTeacherType &&
            this.userHasPermissions(
              'provider.satisfactionquestionnaire.search.resendemail'
            ) &&
            this.IsInProgress,
          click: () => this.resendEmail(),
        },
        {
          name: 'print-questionnaire',
          label: 'Imprimir cuestionario',
          icon: 'mr-2 fas fa-print text-green pr-1',
          border: 'bottom',
          visible:
            this.data.questionnaireTypeId != null &&
            this.isCompleted &&
            this.userHasPermissions('provider.satisfactionquestionnaire.print'),
          click: () => this.printQuestionnaire(),
        },
        {
          name: 'cancel-questionnaire',
          label: 'Cancelar cuestionario',
          icon: 'fas fa-times-circle text-danger pr-1',
          visible:
            !this.isCanceled &&
            this.userHasPermissions(
              'provider.satisfactionquestionnaire.cancancel'
            ),
          click: () => this.openCancelView(),
        },
      ];
    },
    anyVisibleAction() {
      return this.actionItems.some((x) => x.visible);
    },
    isCanceled() {
      return (
        this.data?.statusId ===
        serviceSatisfactionQuestionnaireStatuses.Cancelado
      );
    },
    isCompleted() {
      return (
        this.data?.statusId ===
        serviceSatisfactionQuestionnaireStatuses.Completado
      );
    },
    IsInProgress() {
      return (
        this.data.statusId ===
          serviceSatisfactionQuestionnaireStatuses.Pendiente ||
        this.data.statusId ===
          serviceSatisfactionQuestionnaireStatuses.EnProceso
      );
    },
    isEvaluationTherapyArea() {
      return this.data.areaId === questionnaireArea.EvaluationTherapy;
    },
    isTecnicalAssistance() {
      return this.data.areaId === questionnaireArea.TecnicalAssistance;
    },
    serviceProvider() {
      return this.isEvaluationTherapyArea
        ? this.data.companyName
        : this.data.vendorName;
    },
  },
  watch: {
    'data.email': {
      handler(val) {
        this.email = val;
        this.emailInput = this.data.email;
        this.isEmailEditableMode = false;
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    setIsEditableMode(isEditable = false) {
      this.isEmailEditableMode = isEditable;
    },
    getImageByArea(areaId) {
      switch (areaId) {
        case questionnaireArea.EvaluationTherapy: {
          return this.evaluationThrpyImg;
        }
        case questionnaireArea.Transportation: {
          return this.transportationImg;
        }
        case questionnaireArea.TecnicalAssistance: {
          return this.tecnicalAssistanceImg;
        }
        default:
          return this.evaluationThrpyImg;
      }
    },
    async printQuestionnaire() {
      let report = `satisfactionquestionnaire/${this.data.submissionId}/${this.data.questionnaireTypeId}`;
      await _generalApi.downloadReport(report);
      return;
    },
    async onSaveUpdatedEmail() {
      const isValid = await this.$refs.editableEmailObserver.validate();
      if (!isValid) return;
      this.email = this.emailInput;
      await _updateFamiliarQuestionnaireEmail({
        submissionId: this.data.submissionId,
        email: this.emailInput,
      });
      this.ShowToast(
        'Proceso Exitoso',
        'El correo electrónico se ha actualizado exitosamente.',
        'success'
      );
      this.setIsEditableMode();
    },
    copyUrl() {
      navigator.clipboard.writeText(`${this.data.url}`);
      this.ShowToast(
        'Proceso Exitoso',
        'El enlace ha sido copiado exitosamente.',
        'success'
      );
    },
    async resendEmail() {
      const confirmation = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro(a) que desea enviar el cuestionario nuevamente?`,
        'Si',
        'No'
      );

      if (!confirmation) return;

      try {
        await _resendEmail(this.data.submissionId);
        this.ShowToast(
          'Proceso Exitoso',
          'El correo electrónico se ha reenviado exitosamente.',
          'success'
        );
      } catch (e) {
        this.ShowToast('Error', e.message, 'error');
      }
    },
    async openCancelView() {
      this.isCancelMode = true;
    },
    async abortCancelHandler() {
      this.isCancelMode = false;
    },
    async cancelationHandler(comment) {
      const confirmation = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro(a) que desea cancelar el cuestionario?`,
        'Si',
        'No'
      );

      if (!confirmation) return;

      try {
        const { data: updatedSubmission } = await _cancelQuestionnaire({
          submissionid: this.data.submissionId,
          comment,
        });
        this.$emit('on-cancel', { ...updatedSubmission });
        this.ShowToast(
          'Proceso Exitoso',
          'El cuestionario ha sido cancelado exitosamente.',
          'success'
        );
        this.isCancelMode = false;
      } catch (e) {
        this.ShowToast('Error', e.message, 'error');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/shared/scss/config/_colors.scss';

.icon-type-teacher {
  color: map-get($colors, 'sparkling');
}
::v-deep .row-background-teacher {
  background-color: map-get($colors, 'cold-white') !important;
}
::v-deep .row-background-family {
  background-color: map-get($colors, 'sugar-milk') !important;
}
</style>
